import { create, StateCreator, StoreApi, UseBoundStore } from 'zustand';
import { persist, PersistOptions } from 'zustand/middleware';


type CreatePersistentStoreOptions<T, P = T> = Omit<PersistOptions<T, P>, 'name'> & {
  name?: string;
};

// Define a utility function with generic types
export const createPersistentStore = <T, P = T>(
  name: string,
  storeConfig: StateCreator<T>,
  options: CreatePersistentStoreOptions<T, P> = {} as CreatePersistentStoreOptions<T, P>
): UseBoundStore<StoreApi<T>> => create(persist<T, [], [], P>(storeConfig, { name, ...options }));
